exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-2-wrapper[data-v-6510dbb8]{width:235px;padding-bottom:10px}.top-border[data-v-6510dbb8]{width:calc(100% + 3px);height:8px;margin-bottom:5px;margin-left:-1px}.listing-img[data-v-6510dbb8]{width:50px;height:50px;border-radius:50%;display:inline-block}", ""]);

// exports
